//import { MoneyLinkException } from "@/shared/utils/custom-exception";
import {
  ErrorDialogContext,
  errorHandledAsync,
} from "@/shared/context/error-context";
import { PostCsvExcelAccountsService } from "@/features/accounts/csv-excel/services/post-accounts-service";
import { LoadingModalContext } from "@/shared/components/loading/loading-context";
import { useContext } from "react";


export const usePostCsvExcelAccount = () => {
  // グローバルエラーハンドリング
  const { setError } = useContext(ErrorDialogContext);
  // ローディング用コンテキスト
  const loadingCtx = useContext(LoadingModalContext);

  const postCsvExcelAccountsService = new PostCsvExcelAccountsService();

  // CsvExcel口座登録
  const registerCsvExcelAccounts = async (
    accountGroupId: string,
    passbookName: string,
    accountType: number,
    companyCode?: string,
  ) => {
    loadingCtx.setIsLoading(true);
    try {
      const res = await postCsvExcelAccountsService.postCsvExcelAccounts({
        account_group_id: accountGroupId,
        passbook_name: passbookName,
        account_type: accountType,
        ...(companyCode && { company_code: companyCode }),
      });
      return res.csvexcel_account_id;
    } catch (error) {
      // エラーハンドリング
      console.log("registerCsvExcelAccounts", error);
      throw error;
    } finally {
      loadingCtx.setIsLoading(false);
    }
  };

  return {
    registerCsvExcelAccounts: errorHandledAsync(registerCsvExcelAccounts, setError),
  };
};
